import { useCallback, useMemo, useState } from "react"
import { AuthContext } from "../../shared/types"
import { getTokenFromParent } from "../getTokenFromParent"
import { useAuthDecode } from "../../shared/hooks/useAuthDecode"

export const useParentContext = (): AuthContext => {
  const [token, setToken] = useState<string | null>(null)

  const decode = useAuthDecode()

  const getToken = useCallback(async () => {
    const parentToken = await getTokenFromParent()
    if (parentToken !== undefined) {
      setToken(parentToken)
    }
    return parentToken
  }, [setToken])

  return useMemo(
    (): AuthContext => ({
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      logout: async () => {},
      getToken,

      login: async () => {
        await getToken()
      },

      user: token !== null ? decode(token) : undefined,
      isAuthenticated: token !== null,
      isLoading: false,
    }),
    [decode, token, getToken]
  )
}
